module.exports = __webpack_public_path__ + "media/images/hero_header/hero_header4-d9787ca985ca7a671a2fd43d5af8b361.jpeg";